export const FilePlusIcon2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M16.6654 8.75008V5.66675C16.6654 4.26662 16.6654 3.56655 16.3929 3.03177C16.1532 2.56137 15.7707 2.17892 15.3003 1.93923C14.7656 1.66675 14.0655 1.66675 12.6654 1.66675H7.33203C5.9319 1.66675 5.23183 1.66675 4.69706 1.93923C4.22665 2.17892 3.8442 2.56137 3.60451 3.03177C3.33203 3.56655 3.33203 4.26662 3.33203 5.66675V14.3334C3.33203 15.7335 3.33203 16.4336 3.60451 16.9684C3.8442 17.4388 4.22665 17.8212 4.69706 18.0609C5.23183 18.3334 5.9319 18.3334 7.33203 18.3334H9.9987M11.6654 9.16675H6.66536M8.33203 12.5001H6.66536M13.332 5.83341H6.66536M14.9987 17.5001V12.5001M12.4987 15.0001H17.4987"
        stroke="#344054"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
